<script>
export default {
  name: 'SiteIntro',

  methods: {
    getApp() {
      const { $router, $store } = this;
      $router.push({ name: 'Install' });
      $store.dispatch('analytics/getAppClick', 'Landing_Intro');
    },
  },
};
</script>

<template>
  <div class="intro">
    <h3>
      60 whimsical &amp; relaxing mini&#x2011;meditations
    </h3>
    <!--     <h6 class="subtitle">
      for better sleep, energetic&nbsp;days, &amp;&nbsp;personal&nbsp;insight
    </h6> -->
    <p>
      Fly in a hot air balloon, visit your own lighthouse, hug a bear, and relax in a hammock under
      swaying palm trees&mdash;it&rsquo;s all possible with the power of&nbsp;your&nbsp;mind.
    </p>
    <p>
      These guided mini-meditations will comfort and relax, energize and delight, and transform and
      empower you through the pictures they paint and the gentle questions&nbsp;they&nbsp;ask.
    </p>

    <v-btn
      large
      depressed
      color="primary"
      :ripple="{ class: 'secondary--text' }"
      class="get-app-button"
      @click="getApp"
    >
      Get the app
    </v-btn>
  </div>
</template>

<style lang="scss" scoped>
.intro {
  padding: 1rem 0;
  text-align: center;
  box-sizing: border-box;

  .xl & {
    padding: 1.25rem 0.5rem;
  }

  > h3 {
    margin-bottom: 1rem;
  }

  p {
    font-size: 1.1em;
    margin-bottom: 0.6rem;
  }

  // .subtitle {
  //   margin-top: 0;
  //   margin-bottom: 1rem;
  //   font-size: 1.2rem;
  //   letter-spacing: 0;
  // }
}
</style>
